import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { React, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { useForm } from 'react-hook-form';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from "../../ui-elements/MyMButton";
import { MyMCheckBox } from '../../ui-elements/MyMCheckBox';
import { MyMDatePicker } from "../../ui-elements/MyMDatePicker";
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel } from "../../ui-elements/MyMLabel";
import { MyMProgress } from '../../ui-elements/MyMProgress';
import ValidatableDatePicker from '../../ui-parts/ValidatableDatePicker';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { format } from 'react-string-format';

/**MyMine Version2.0 SurveyRegistration画面新規追加
 * SurveyRegistration Page Component
 */
export const SurveyRegistration = (props) => {
  const { surveyId, handleModalClose, callbackUpdateSurvey } = props;
  const screenId = 'MyM804';
  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const validationRules = useValidationRules();
  const apiRequest = useMyMApi(screenId);
  const [surveyItem, setSurveyItem] = useState({
    SurveyMstData: {
      Description: "",
      StartDate: "",
      EndDate: "",
      Status: "",
      IsCurrentSurvey: null,
      IsEndSurvey: null,
    },
    QuestionList: [{
      QuestionText: "",
      QuestionId: null,
      SurveyId: null,
      AnswerType: "",
      OrderNo: null,
      // 2025.7.7 MyMine Version3.0対応 Add Start
      RequiredFlg: false,
      QuestionOptionList: null,
      // 2025.7.7 MyMine Version3.0対応 Add End
    }],

  });
  const [maxQuestionId, setMaxQuestionId] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaveasDraftHandleValid, setIsSaveasDraftHandleValid] = useState(true);
  const { formState, control, setValue, trigger, clearErrors } = useForm({
    mode: 'onSubmit',
  })
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(surveyItem.QuestionList);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    const updatedItems = items.map((item, index) => ({
      ...item,
      OrderNo: index + 1
    }));
    setSurveyItem(prev => ({
      ...prev,
      QuestionList: updatedItems
    }));
  };



  useEffect(() => {
    const callbackRequestSurveyInfo = (result) => {
      clearErrors();
      setSurveyItem(result);
      setValue("headerLabel", ...result.SurveyMstData.Description);
      setValue("startDate", dayjs(result.SurveyMstData.StartDate));
      setValue("endDate", dayjs(result.SurveyMstData.EndDate));
      result.QuestionList.forEach((question) => {
        setValue(`questionText_${question.QuestionId}`, question.QuestionText)
        // 2025.7.7 MyMine Version3.0対応 Add Start
        question.QuestionOptionList?.map((option) =>
          setValue(`question${question.QuestionId}_option${option.OptionId}_text`, option.OptionText)
        );
        // 2025.7.7 MyMine Version3.0対応 Add End
      });
      result.QuestionList.forEach((question) =>
        setMaxQuestionId(question.QuestionId)
      );
      if (result.QuestionList.length === 0) {
        const newQuestionId = maxQuestionId + 1;
        const newQuestion = {
          QuestionId: newQuestionId,
          SurveyId: null,
          // 2025.7.7 MyMine Version3.0対応 Modify Start
          AnswerType: constants.SurveyAnswerType.Checkbox,
          // 2025.7.7 MyMine Version3.0対応 Modify End
          QuestionText: "",
          OrderNo: 1,
          // 2025.7.7 MyMine Version3.0対応 Add Start
          QuestionOptionList: [{ OptionId: 1, OptionText: '', OtherFlg: false }]
          // 2025.7.7 MyMine Version3.0対応 Add End
        };
        setSurveyItem((prevState) => ({
          ...prevState,
          QuestionList: [newQuestion],
        }));
        setValue(`questionText_${newQuestionId}`, newQuestion.QuestionText); // Set the value for the new question
        setMaxQuestionId(newQuestionId);
      }
      setIsLoading(false);
    };
    apiRequest.requestJson(`api/survey/survey-Info-load?surveyId=${surveyId}`, 'GET', callbackRequestSurveyInfo);
  }, []);


  const handleQuestionChange = (questionId, field, value) => {

    // 2025.7.7 MyMine Version3.0対応 Add Start
    const question = surveyItem.QuestionList.find(question => question.QuestionId === questionId);
    if (field === 'AnswerType' && isOptionEnabledQuestion(value) && question.QuestionOptionList == null) {
      question.QuestionOptionList = [{ OptionId: 1, OptionText: '', OtherFlg: false }]
    }
    // 2025.7.7 MyMine Version3.0対応 Add End

    setSurveyItem(prev => ({
      ...prev,
      QuestionList: prev.QuestionList.map(q =>
        q.QuestionId === questionId ? { ...q, [field]: value } : q
      )
    }));
  };
  const addQuestion = async () => {
    clearErrors();
    const newQuestionId = maxQuestionId + 1;
    const newQuestion = {
      QuestionId: newQuestionId,
      SurveyId: null,
      // 2025.7.7 MyMine Version3.0対応 Modify Start
      AnswerType: constants.SurveyAnswerType.Checkbox,
      // 2025.7.7 MyMine Version3.0対応 Modify End
      QuestionText: "",
      OrderNo: null,
      // 2025.7.7 MyMine Version3.0対応 Add Start
      RequiredFlg: false,
      QuestionOptionList: [{ OptionId: 1, OptionText: '', OtherFlg: false }]
      // 2025.7.7 MyMine Version3.0対応 Add End
    }

    // 既存の質問リストを取得
    const updatedQuestions = [...surveyItem.QuestionList, newQuestion];
    if (updatedQuestions.length <= screenSettings.MaxNumberOfQuestion) {
      // OrderNoを再計算
      const updatedQuestionsWithOrderNo = updatedQuestions.map((question, index) => ({
        ...question,
        OrderNo: index + 1, // 1から始まる順序
      }));
      // ステートを更新
      await setSurveyItem(prev => ({
        ...prev,
        QuestionList: updatedQuestionsWithOrderNo,
      }));
      setMaxQuestionId(newQuestionId);
    }
    else {
      window.alert(messageList.MyM_MSG_E_0116);
    }
  };

  const trashQuestion = (questionId) => {
    const newQuestion = surveyItem.QuestionList;
    if (newQuestion.length !== 1) {
      setSurveyItem(prev => {
        const updatedQuestions = prev.QuestionList.filter(item => item.QuestionId !== questionId);
        const updatedQuestionsWithOrderNo = updatedQuestions.map((item, index) => ({
          ...item,
          OrderNo: index + 1, // OrderNoを再計算
        }));
        return {
          ...prev,
          QuestionList: updatedQuestionsWithOrderNo
        };
      });
    }
    else {
      window.alert(messageList.MyM_MSG_E_0107);
    }
  };

  const callbackSuccessSaveasDraft = () => {
    handleModalClose();
    callbackUpdateSurvey && callbackUpdateSurvey();
    window.alert(messageList.MyM_MSG_I_0101);
    setIsLoading(false);
  }
  const callbackFailedContext = () => {
    setIsLoading(false);
  }

  const onClickSaveasDraft = async () => {
    if (surveyItem.QuestionList.length < 1) {
      window.alert(messageList.MyM_MSG_E_0136);
      return
    };
    clearErrors();
    //Descriptionフィールドの検証
    const descriptionCheckresult = await trigger("headerLabel");
    //StartDateフィールドの検証
    const startDateCheckresult = await trigger("startDate");
    //EndDateフィールドの検証
    const endDateCheckresult = await trigger("endDate");
    //QuestionTextフィールドの検証
    const questionTextCheckresults = await Promise.all(
      surveyItem.QuestionList.map(async (question) => {
        let questionCheckResult = await trigger(`questionText_${question.QuestionId}`);

        // 2025.7.7 MyMine Version3.0対応 Add Start
        // Optionがある場合、Optionフィールドの検証
        if (question.QuestionOptionList) {
          const optionTextCheckResults = await Promise.all(
            question.QuestionOptionList.map(async (option) => {
              const questionOptionCheckResult = await trigger(`question${question.QuestionId}_option${option.OptionId}_text`);
              return { optionId: option.OptionId, result: questionOptionCheckResult };
            })
          );
          if (optionTextCheckResults.some(x => x.result !== true)) {
            questionCheckResult = false;
          }
        }
        // 2025.7.7 MyMine Version3.0対応 Add End

        return { questionId: question.QuestionId, result: questionCheckResult };
      })
    );
    const result = descriptionCheckresult && startDateCheckresult && endDateCheckresult && questionTextCheckresults.every((result) => result.result === true);
    setIsSaveasDraftHandleValid(result);
    if (result) {
      if (!window.confirm(messageList.MyM_MSG_I_0100)) return;
      setIsLoading(true);

      const newQuestion = surveyItem.QuestionList;

      const surveyData = {
        SurveyMstData: {
          SurveyId: surveyId !== 0 ? surveyId : surveyItem.SurveyMstData.SurveyId,
          Description: surveyItem.SurveyMstData.Description,
          StartDate: surveyItem.SurveyMstData.StartDate,
          EndDate: surveyItem.SurveyMstData.EndDate,
          Status: constants.SurveyStatus.Draft,
        },
        QuestionList: newQuestion.map(question => ({
          QuestionId: question.QuestionId,
          QuestionText: question.QuestionText,
          AnswerType: question.AnswerType,
          OrderNo: question.OrderNo,
          SurveyId: surveyId !== 0 ? surveyId : surveyItem.SurveyMstData.SurveyId,
          // 2025.7.7 MyMine Version3.0対応 Add Start
          RequiredFlg: question.RequiredFlg,
          QuestionOptionList: question.QuestionOptionList,
          // 2025.7.7 MyMine Version3.0対応 Add End
        })),
      };
      const url = surveyId !== 0 ? `api/survey/survey-update` : `api/survey/newsurvey-insert`;
      apiRequest.requestJson(url, 'POST', callbackSuccessSaveasDraft, callbackFailedContext, surveyData);
    }
    else {
      onError();
    }
  };
  const callbackSuccessSchedule = () => {
    handleModalClose();
    callbackUpdateSurvey && callbackUpdateSurvey();
    window.alert(messageList.MyM_MSG_I_0105);
    setIsLoading(false);
  };
  //Scheduleボタン押下時
  const onClickSchedule = async () => {
    if (surveyItem.QuestionList.length < 1) {
      window.alert(messageList.MyM_MSG_E_0136);
      return
    };
    clearErrors();
    //Descriptionフィールドの検証
    const descriptionCheckresult = await trigger("headerLabel");
    //StartDateフィールドの検証
    const startDateCheckresult = await trigger("startDate");
    //EndDateフィールドの検証
    const endDateCheckresult = await trigger("endDate");
    //QuestionTextフィールドの検証
    const questionTextCheckresults = await Promise.all(
      surveyItem.QuestionList.map(async (question) => {
        let questionCheckResult = await trigger(`questionText_${question.QuestionId}`);

        // 2025.7.7 MyMine Version3.0対応 Add Start
        // Optionがある場合、Optionフィールドの検証
        if (question.QuestionOptionList) {
          const optionTextCheckResults = await Promise.all(
            question.QuestionOptionList.map(async (option) => {
              const questionOptionCheckResult = await trigger(`question${question.QuestionId}_option${option.OptionId}_text`);
              return { optionId: option.OptionId, result: questionOptionCheckResult };
            })
          );
          if (optionTextCheckResults.some(x => x.result !== true)) {
            questionCheckResult = false;
          }
        }
        // 2025.7.7 MyMine Version3.0対応 Add End
        return { questionId: question.QuestionId, result: questionCheckResult };
      })
    );
    const result = descriptionCheckresult && startDateCheckresult && endDateCheckresult && questionTextCheckresults.every((result) => result.result === true);

    if (result) {
      if (!window.confirm(messageList.MyM_MSG_I_0104)) return;
      setIsLoading(true);

      const newQuestion = surveyItem.QuestionList;

      const surveyData = {
        SurveyMstData: {
          SurveyId: surveyId !== 0 ? surveyId : surveyItem.SurveyMstData.SurveyId,
          Description: surveyItem.SurveyMstData.Description,
          StartDate: surveyItem.SurveyMstData.StartDate,
          EndDate: surveyItem.SurveyMstData.EndDate,
          Status: constants.SurveyStatus.Scheduled,
        },
        QuestionList: newQuestion.map(question => ({
          QuestionId: question.QuestionId,
          QuestionText: question.QuestionText,
          AnswerType: question.AnswerType,
          OrderNo: question.OrderNo,
          SurveyId: surveyId !== 0 ? surveyId : surveyItem.SurveyMstData.SurveyId,
          // 2025.7.7 MyMine Version3.0対応 Add Start
          RequiredFlg: question.RequiredFlg,
          QuestionOptionList: question.QuestionOptionList,
          // 2025.7.7 MyMine Version3.0対応 Add End
        })),
      };
      const url = surveyId !== 0 ? `api/survey/survey-update` : `api/survey/newsurvey-insert`;
      apiRequest.requestJson(url, 'POST', callbackSuccessSchedule, callbackFailedContext, surveyData);
    }
    else {
      onError();
    }
  };
  //入力チェック

  const onError = () => {
    window.alert(messageList.MyM_MSG_E_0003);
  };


  // 2025.7.7 MyMine Version3.0対応 Add Start

  /**
   * Option行ドラッグ終了（並べ替え）イベント
   * @param {object} result
   * @param {number} questionId
   */
  const handleOptionDragEnd = (result, questionId) => {
    if (!result.destination) return;

    const questionItem = surveyItem.QuestionList.find(question => question.QuestionId === questionId);
    const [reorderedItem] = questionItem.QuestionOptionList.splice(result.source.index, 1);
    questionItem.QuestionOptionList.splice(result.destination.index, 0, reorderedItem);
  };

  /**
   * Optionか有効なQuestionTypeかどうかを返す
   * @param {number} questionType QuestionType
   * @returns Option有効時:true
   */
  const isOptionEnabledQuestion = (questionType) => {
    return questionType === constants.SurveyAnswerType.Checkbox || questionType === constants.SurveyAnswerType.Radiobutton;
  }

  /**
   * Add Option押下時イベント
   * @param {number} questionId 押下したQuestionId
   * @param {boolean} isOther Add Others Optionの場合、true
   */
  const onClickAddOption = (questionId, isOther) => {

    const question = surveyItem.QuestionList.find(question => question.QuestionId === questionId);
    const addOptionText = isOther ? controlSettings.LabelList.txtOther : '';

    const addOptionData = { OptionId: 1, OptionText: addOptionText, OtherFlg: isOther };
    if (question.QuestionOptionList) {

      // Option件数が上限になっている場合、メッセージを表示し終了
      if (question.QuestionOptionList.length >= screenSettings.MaxNumberOfQuestionOption) {
        const message_0158 = format(
          messageList.MyM_MSG_E_0158,
          screenSettings.MaxNumberOfQuestionOption
        );

        alert(message_0158);
        return;
      }

      // Other Option追加 且つ 既にOther Optionがある場合、メッセージを表示し終了
      if (isOther && question.QuestionOptionList.some(option => option.OtherFlg)) {
        alert(messageList.MyM_MSG_E_0160)
        return;
      }

      // OptionIdをMax値 + 1に設定
      addOptionData.OptionId = Math.max(...question.QuestionOptionList.map(item => item.OptionId)) + 1;

      // OtherOptionデータを取得
      const index = question.QuestionOptionList.findIndex(x => x.OtherFlg === true);
      if (index !== -1) {
        // OtherOptionデータが既にある場合はその前に挿入
        question.QuestionOptionList.splice(index, 0, addOptionData);
      } else {
        // なければ末尾に追加
        question.QuestionOptionList.push(addOptionData);
      }

    } else {
      question.QuestionOptionList = [addOptionData];
    }

    setValue(`question${question.QuestionId}_option${addOptionData.OptionId}_text`, addOptionText);
    setSurveyItem(prev => ({
      ...prev,
      QuestionList: surveyItem.QuestionList
    }));
  }
  // 2025.7.7 MyMine Version3.0対応 Add End

  const endDate = dayjs(surveyItem.SurveyMstData.EndDate); // dayjs インスタンス
  const addEndDate = endDate.add(30, 'day')
  const formattedDate = addEndDate.format('YYYY/MM/DD'); // 'YYYY-MM-DD' などの形式に変換

  if (surveyItem.SurveyMstData.Description === "" &&
    surveyItem.SurveyMstData.StartDate === "" &&
    surveyItem.SurveyMstData.EndDate === "" &&
    surveyItem.SurveyMstData.IsCurrentSurvey === null &&
    surveyItem.SurveyMstData.IsEndSurvey === null)
    return <MyMProgress />
  return (
    <Box sx={{ paddingLeft: "5px", paddingTop: '5px', height: "100%", overflowY: "auto" }}>
      {isLoading && <MyMProgress />}
      <Grid container alignItems="center" justify="center">
        <Stack direction='row' spacing={1} className='d-flex align-items-start' alignItems='center' sx={{ paddingTop: '20px' }}>
          <Grid item>
            <MyMLabel fontWeight='bold' fontSize='30px' sx={{ marginRight: '20px' }}>{controlSettings.LabelList.lblTerm}</MyMLabel>
          </Grid>
          {!surveyItem.SurveyMstData.IsCurrentSurvey && !surveyItem.SurveyMstData.IsEndSurvey ?
            //ステータスがDraft・Scheduledの場合
            <>
              <Grid item >

                < ValidatableDatePicker
                  name="startDate"
                  onChange={async (date) => {
                    setValue("startDate", date); // 日付を更新
                    setSurveyItem(prev => ({
                      ...prev,
                      SurveyMstData: { ...prev.SurveyMstData, "StartDate": date !== null ? date?.$d.toLocaleString() : null } // 状態も更新
                    }));
                    isSaveasDraftHandleValid && await trigger("startDate");
                  }}
                  value={dayjs(surveyItem.SurveyMstData.StartDate)}
                  width="100%"
                  control={control}
                  formState={formState}
                  rules={{
                    ...validationRules.required(),
                    ...validationRules.date("StartDate", true)
                  }}
                />

              </Grid>
              <Grid item>
                <Box fontWeight='bold' sx={{ paddingTop: '10px' }}>
                  ～
                </Box>
              </Grid>
              <Grid item >
                <ValidatableDatePicker
                  name="endDate"
                  value={dayjs(surveyItem.SurveyMstData.EndDate)}
                  width="100%"
                  control={control}
                  formState={formState}
                  rules={{
                    ...validationRules.required(),
                    ...validationRules.date("EndDate", true, dayjs(surveyItem.SurveyMstData.StartDate))
                  }}
                  onChange={async (date) => {
                    setValue("endDate", date); // 日付を更新
                    setSurveyItem(prev => ({
                      ...prev,
                      SurveyMstData: { ...prev.SurveyMstData, EndDate: date !== null ? date?.$d.toLocaleString() : null } // 状態も更新
                    }));
                    isSaveasDraftHandleValid && await trigger("endDate");
                  }}
                />
              </Grid>
            </>
            :
            //ステータスがActive・Closedの場合
            <>
              <Grid item>
                < MyMDatePicker
                  name="startDate"
                  value={dayjs(surveyItem.SurveyMstData.StartDate)}
                  width="230px"
                  control={control}
                  formState={formState}
                  disabled
                />
              </Grid>
              <Grid item>
                <Box fontWeight='bold' sx={{ paddingTop: '10px' }}>
                  ～
                </Box>
              </Grid>
              <Grid item>
                <MyMDatePicker
                  name="endDate"
                  value={dayjs(surveyItem.SurveyMstData.EndDate)}
                  width="230px"
                  control={control}
                  formState={formState}
                  rules={{
                    ...validationRules.required(),
                    ...validationRules.date("endDate",),
                  }}
                  disabled
                />
              </Grid>
            </>
          }

        </Stack>
      </Grid>
      <Grid container sx={{ paddingTop: '5px', paddingRight: '400px', justifyContent: 'center' }}>
        <Grid >
          <MyMLabel sx={{}}>{controlSettings.LabelList.lblCaution}</MyMLabel>
        </Grid>
        <Grid>
          <MyMLabel sx={{ paddingLeft: '10px', fontWeight: 'bold' }}>{formattedDate}</MyMLabel>
        </Grid>
      </Grid>

      <Box >
        {/*HeaderLabel*/}
        <Grid sx={{ paddingTop: "30px" }}>
          <MyMLabel fontWeight='bold' fontSize='30px'>{controlSettings.LabelList.lblHeader}</MyMLabel>
        </Grid>
        <Box margin="20px" >
          <ValidatableTextBox
            control={control}
            width="80%"
            rows={3}
            multiline={true}
            formState={formState}
            disabled={surveyItem.SurveyMstData.IsCurrentSurvey || surveyItem.SurveyMstData.IsEndSurvey}
            name="headerLabel"
            value={surveyItem.SurveyMstData.Description} // 値をセット
            maxLength={screenSettings.MaxTextLength}
            onChange={async (e) => {
              setSurveyItem(prev => ({
                ...prev,
                SurveyMstData: { ...prev.SurveyMstData, Description: e.target.value } // 状態を更新
              }));
              isSaveasDraftHandleValid && await trigger("headerLabel");
            }}

            rules={{
              ...validationRules.required(),
              ...validationRules.maxLength(screenSettings.MaxTextLength),
            }}
          />
        </Box>
      </Box>
      {/*Question*/}
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable-questions" >
          {(provided) => (
            <Grid ref={provided.innerRef} {...provided.droppableProps}
            >
              {surveyItem.QuestionList.map((question, index) => (
                !surveyItem.SurveyMstData.IsCurrentSurvey && !surveyItem.SurveyMstData.IsEndSurvey ?
                  (
                    //ステータスがDraft・Scheduledの場合
                    <Draggable key={question.QuestionId} draggableId={String(question.QuestionId)} index={index}>
                      {(provided) => (
                        <Grid container alignItems="center" {...provided.draggableProps} ref={provided.innerRef}
                          style={{
                            ...provided.draggableProps.style,
                          }}
                        >
                          <Grid item {...provided.dragHandleProps} alignItems="center" sx={{ paddingRight: '30px' }}>
                            <MyMImage
                              screenId={screenId}
                              filePath={controlSettings.ImageList.imgReorder}
                            />
                          </Grid>

                          <Grid item xs alignItems="center" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <Grid sx={{ marginBottom: '40px' }} />
                            <Grid container sx={{ paddingBottom: '10px' }} >
                              <MyMLabel fontWeight="bold">{question.OrderNo}</MyMLabel>
                              <MyMLabel fontWeight="bold"> {controlSettings.LabelList.lblQuestion}</MyMLabel>
                            </Grid>

                            {/* ValidatableTextBox */}
                            <Grid container alignItems="center" spacing={1} sx={{ width: '100%' }}>
                              <ValidatableTextBox
                                control={control}
                                name={`questionText_${question.QuestionId}`}
                                onChange={async (e) => {
                                  await handleQuestionChange(question.QuestionId, 'QuestionText', e.target.value);
                                  await trigger(`questionText_${question.QuestionId}`);
                                }}
                                value={question.QuestionText}
                                maxLength={screenSettings.MaxTextLength}
                                multiline={true}
                                formState={formState}
                                rows={4}
                                sx={{ width: '80%' }}
                                rules={{
                                  ...validationRules.required(),
                                  ...validationRules.maxLength(screenSettings.MaxTextLength),
                                }}
                              />
                              <Grid sx={{ paddingLeft: '20px' }}>
                                <MyMButton
                                  onClick={() => trashQuestion(question.QuestionId)}
                                >
                                  <MyMImage
                                    screenId={screenId}
                                    filePath={controlSettings.ImageList.btnTrash}
                                    width="45px"
                                  />
                                </MyMButton>
                              </Grid>
                            </Grid>

                            {/* RadioGroup */}
                            <Grid container alignItems="center">
                              {/* 2025.7.7 MyMine Version3.0対応 Add Start */}
                              <Grid item xs={12}>
                                <MyMCheckBox
                                  label={controlSettings.LabelList.lblRequiredQuestion}
                                  checked={question.RequiredFlg ?? false}
                                  onChange={(e) => handleQuestionChange(question.QuestionId, 'RequiredFlg', e.target.checked)}
                                />
                              </Grid>
                              {/* 2025.7.7 MyMine Version3.0対応 Add End */}
                              <Grid item xs={12}>
                                <RadioGroup
                                  aria-label="question"
                                  name={`answerType_${question.QuestionId}`}
                                  value={question.AnswerType}
                                  row
                                  onChange={(e) => handleQuestionChange(question.QuestionId, 'AnswerType', e.target.value)}
                                >
                                  {/* 2025.7.7 MyMine Version3.0対応 Add Start */}
                                  <FormControlLabel
                                    value={constants.SurveyAnswerType.Checkbox}
                                    control={<Radio />}
                                    label={controlSettings.LabelList.lblMultiSelect}
                                  />
                                  <FormControlLabel
                                    value={constants.SurveyAnswerType.Radiobutton}
                                    control={<Radio />}
                                    label={controlSettings.LabelList.lblSingleSelect}
                                  />
                                  {/* 2025.7.7 MyMine Version3.0対応 Add End */}
                                  <FormControlLabel
                                    value={constants.SurveyAnswerType.Option}
                                    control={<Radio />}
                                    // 2025.7.7 MyMine Version3.0対応 Modify Start
                                    label={controlSettings.LabelList.lblScale}
                                  // 2025.7.7 MyMine Version3.0対応 Modify End
                                  />
                                  <FormControlLabel
                                    value={constants.SurveyAnswerType.Text}
                                    control={<Radio />}
                                    label={controlSettings.LabelList.lblText}
                                  />
                                </RadioGroup>
                                {/* 2025.7.7 MyMine Version3.0対応 Add Start */}
                                {isOptionEnabledQuestion(question.AnswerType) &&
                                  <Grid item xs={12}>
                                    <DragDropContext onDragEnd={(result) => handleOptionDragEnd(result, question.QuestionId)}>
                                      <Droppable droppableId="droppable-question-options" >
                                        {(provided) => (
                                          <Stack className='ms-3' ref={provided.innerRef} {...provided.droppableProps}>
                                            {question.QuestionOptionList?.filter(option => option.OtherFlg === false).map((option, optionIndex) =>

                                              <Draggable key={option.OptionId} draggableId={String(option.OptionId)} index={optionIndex}>
                                                {(provided) =>
                                                  <SurveyQuestionOptionRow
                                                    screenId={screenId}
                                                    control={control}
                                                    trigger={trigger}
                                                    formState={formState}
                                                    provided={provided}
                                                    surveyItem={surveyItem}
                                                    setSurveyItem={setSurveyItem}
                                                    question={question}
                                                    option={option}
                                                    rowIndex={optionIndex}
                                                  />
                                                }
                                              </Draggable>
                                            )}
                                            {provided.placeholder}


                                            {question.QuestionOptionList?.some(option => option.OtherFlg === true) &&
                                              <SurveyQuestionOptionRow
                                                screenId={screenId}
                                                control={control}
                                                trigger={trigger}
                                                formState={formState}
                                                surveyItem={surveyItem}
                                                setSurveyItem={setSurveyItem}
                                                question={question}
                                                option={question.QuestionOptionList.find(option => option.OtherFlg === true)}
                                                rowIndex={question.QuestionOptionList.length - 1}
                                              />
                                            }

                                            <Stack direction='row' spacing={3}>
                                              <MyMButton onClick={() => onClickAddOption(question.QuestionId, false)}>{controlSettings.LabelList.btnAddOption}</MyMButton>
                                              <MyMButton onClick={() => onClickAddOption(question.QuestionId, true)}>{controlSettings.LabelList.btnAddOtherOption}</MyMButton>
                                            </Stack>

                                          </Stack>

                                        )}
                                      </Droppable>
                                    </DragDropContext>
                                  </Grid>
                                }
                                {/* 2025.7.7 MyMine Version3.0対応 Add End */}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                      )}
                    </Draggable>
                  )
                  :
                  (
                    //ステータスがActive・Closedの場合
                    <Grid container alignItems="center" key={question.QuestionId}>
                      <Grid item xs alignItems="center" sx={{ display: 'flex', flexDirection: 'column', paddingLeft: '20px' }}>
                        <Grid sx={{ marginBottom: '40px' }} />
                        <Grid container sx={{ paddingBottom: '10px' }}>
                          <MyMLabel fontWeight='bold'>{question.OrderNo} </MyMLabel>
                          <MyMLabel fontWeight='bold'> {controlSettings.LabelList.lblQuestion}</MyMLabel>
                        </Grid>
                        {/* ValidatableTextBox */}
                        <Grid container alignItems="center" spacing={1} sx={{ width: '100%' }}>
                          {/*Closedの場合非活性*/}
                          <ValidatableTextBox
                            control={control}
                            name={`questionText_${question.QuestionId}`}
                            onChange={async (e) => {
                              await handleQuestionChange(question.QuestionId, 'QuestionText', e.target.value);
                              await trigger(`questionText_${question.QuestionId}`);
                            }}
                            value={question.QuestionText}
                            maxLength={screenSettings.MaxTextLength}
                            multiline={true}
                            formState={formState}
                            rows={4}
                            sx={{ width: '80%' }}
                            rules={{
                              ...validationRules.required(),
                              ...validationRules.maxLength(screenSettings.MaxTextLength),
                            }}
                            disabled={surveyItem.SurveyMstData.IsEndSurvey}
                          />

                        </Grid>

                        {/* RadioGroup */}
                        <Grid container alignItems="center">
                          {/* 2025.7.7 MyMine Version3.0対応 Add Start */}
                          <Grid item xs={12}>
                            <MyMCheckBox
                              label={controlSettings.LabelList.lblRequiredQuestion}
                              checked={question.RequiredFlg}
                              onChange={(e) => handleQuestionChange(question.QuestionId, 'RequiredFlg', e.target.checked)}
                              disabled
                            />
                          </Grid>
                          {/* 2025.7.7 MyMine Version3.0対応 Add End */}
                          <Grid item xs={12}>
                            <RadioGroup
                              aria-label="question"
                              name={`answerType_${question.QuestionId}`}
                              value={question.AnswerType}
                              row
                            >
                              {/* 2025.7.7 MyMine Version3.0対応 Add Start */}
                              <FormControlLabel
                                value={constants.SurveyAnswerType.Checkbox}
                                control={<Radio />}
                                label={controlSettings.LabelList.lblMultiSelect}
                                disabled
                              />
                              <FormControlLabel
                                value={constants.SurveyAnswerType.Radiobutton}
                                control={<Radio />}
                                label={controlSettings.LabelList.lblSingleSelect}
                                disabled
                              />
                              {/* 2025.7.7 MyMine Version3.0対応 Add End */}
                              <FormControlLabel
                                value={constants.SurveyAnswerType.Option}
                                control={<Radio />}
                                // 2025.7.7 MyMine Version3.0対応 Modify Start
                                label={controlSettings.LabelList.lblScale}
                                // 2025.7.7 MyMine Version3.0対応 Modify End
                                disabled
                              />
                              <FormControlLabel
                                value={constants.SurveyAnswerType.Text}
                                control={<Radio />}
                                label={controlSettings.LabelList.lblText}
                                disabled
                              />
                            </RadioGroup>
                          </Grid>
                          {/* 2025.7.7 MyMine Version3.0対応 Add Start */}
                          {isOptionEnabledQuestion(question.AnswerType) &&
                            <Grid item xs={12}>
                              <Stack className='ms-3'>
                                {question.QuestionOptionList?.filter(option => option.OtherFlg === false).map((option, optionIndex) =>
                                  <SurveyQuestionOptionRow
                                    key={option.OptionId}
                                    screenId={screenId}
                                    control={control}
                                    trigger={trigger}
                                    formState={formState}
                                    surveyItem={surveyItem}
                                    setSurveyItem={setSurveyItem}
                                    question={question}
                                    option={option}
                                    rowIndex={optionIndex}
                                    onlyEnableTextChanged={true}
                                  />
                                )}
                                {provided.placeholder}
                                {question.QuestionOptionList?.some(option => option.OtherFlg === true) &&
                                  <SurveyQuestionOptionRow
                                    screenId={screenId}
                                    control={control}
                                    trigger={trigger}
                                    formState={formState}
                                    surveyItem={surveyItem}
                                    setSurveyItem={setSurveyItem}
                                    question={question}
                                    option={question.QuestionOptionList.find(option => option.OtherFlg === true)}
                                    rowIndex={question.QuestionOptionList.length - 1}
                                    onlyEnableTextChanged={true}
                                  />
                                }

                                <Stack direction='row' spacing={3}>
                                  <MyMButton disabled>{controlSettings.LabelList.btnAddOption}</MyMButton>
                                  <MyMButton disabled>{controlSettings.LabelList.btnAddOtherOption}</MyMButton>
                                </Stack>

                              </Stack>
                            </Grid>
                          }
                          {/* 2025.7.7 MyMine Version3.0対応 Add End */}
                        </Grid>
                      </Grid>
                    </Grid>

                  )
              ))}
              {provided.placeholder}
            </Grid>
          )}
        </Droppable>
        <Grid sx={{ paddingTop: (surveyItem.SurveyMstData.IsCurrentSurvey || surveyItem.SurveyMstData.IsEndSurvey) && "20px" }}>
          <MyMButton disabled={surveyItem.SurveyMstData.IsCurrentSurvey || surveyItem.SurveyMstData.IsEndSurvey} onClick={addQuestion}>{controlSettings.LabelList.btnAddItem}</MyMButton>
        </Grid>
      </DragDropContext>
      <Grid container alignItems="center" spacing={3} sx={{ padding: '25px 40px 25px 0px', justifyContent: "flex-end" }}>
        <Grid item>
          {!surveyItem.SurveyMstData.IsCurrentSurvey && !surveyItem.SurveyMstData.IsEndSurvey && <MyMButton onClick={onClickSaveasDraft} >{controlSettings.LabelList.btnSaD}</MyMButton>}
        </Grid>
        <Grid item>
          {!surveyItem.SurveyMstData.IsEndSurvey && <MyMButton onClick={onClickSchedule}>{controlSettings.LabelList.btnSchedule}</MyMButton>}
        </Grid>
        <Grid item>
          <MyMButton onClick={handleModalClose}>{controlSettings.LabelList.btnClose}</MyMButton>
        </Grid>
      </Grid>
    </Box >
  );

};

// 2025.7.7 MyMine Version3.0対応 Add Start
const SurveyQuestionOptionRow = ({ screenId, control, trigger, formState, provided, surveyItem, setSurveyItem, question, option, rowIndex, onlyEnableTextChanged }) => {

  const { controlSettings, messageList, screenSettings } = useWebContext(screenId);
  const validationRules = useValidationRules();

  /**
   * Optionデータ変更イベント
   * @param {any} questionId
   * @param {any} optionId
   * @param {any} field
   * @param {any} value
   */
  const handleQuestionOptionChange = (questionId, optionId, field, value) => {
  setSurveyItem(prev => {
    const newList = prev.QuestionList.map(q => {
      if (q.QuestionId !== questionId) return q;
      return {
        ...q,
        QuestionOptionList: q.QuestionOptionList.map(opt =>
          opt.OptionId === optionId ? { ...opt, [field]: value } : opt
        )
      };
    });
    return { ...prev, QuestionList: newList };
  });
};

  /**
   * Option行のTrashボタン押下イベント
   * @param {any} questionId
   * @param {any} optionId
   */
  const onClickTrashIcon = (questionId, optionId) => {
    const question = surveyItem.QuestionList.find(question => question.QuestionId === questionId);
    if (question.QuestionOptionList.length !== 1) {
      question.QuestionOptionList = question.QuestionOptionList.filter(item => item.OptionId !== optionId)
      setSurveyItem(prev => ({
        ...prev,
        QuestionList: surveyItem.QuestionList
      }));
    }
    else {
      window.alert(messageList.MyM_MSG_E_0159);
    }
  };


  return (
    <Stack
      direction='row'
      spacing={2}
      className='mb-3'
      {...provided?.draggableProps}
      ref={provided?.innerRef}
      style={{
        ...provided?.draggableProps.style,
      }}>
      <MyMLabel sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', minWidth: 95 }}>
        {option.OtherFlg ? controlSettings.LabelList.lblOptionOther : `${controlSettings.LabelList.lblOption} ${rowIndex + 1}`}
      </MyMLabel>

      <MyMImage
        {...provided?.dragHandleProps}
        screenId={screenId}
        filePath={controlSettings.ImageList.imgReorder}
        height='40px'
        style={{ display: onlyEnableTextChanged ? 'none' : 'block', visibility: option.OtherFlg ? 'hidden' : 'block' }}
      />

      <ValidatableTextBox
        control={control}
        name={`question${question.QuestionId}_option${option.OptionId}_text`}
        onChange={async (e) => {
          await handleQuestionOptionChange(question.QuestionId, option.OptionId, 'OptionText', e.target.value);
          await trigger(`question${question.QuestionId}_option${option.OptionId}_text`);
        }}
        disabled={option.OtherFlg || surveyItem.SurveyMstData.IsEndSurvey}
        value={option.OptionText}
        maxLength={screenSettings.MaxOptionTextLength}
        formState={formState}
        width='60%'
        rules={{
          ...validationRules.required(),
          ...validationRules.maxLength(screenSettings.MaxOptionTextLength),
        }}
      />

      <MyMButton
        onClick={() => onClickTrashIcon(question.QuestionId, option.OptionId)}
        sx={{ display: onlyEnableTextChanged ? 'none' : 'block' }}
      >
        <MyMImage
          screenId={screenId}
          filePath={controlSettings.ImageList.btnTrash}
          width="25px"
        />
      </MyMButton>
    </Stack>);
}
// 2025.7.7 MyMine Version3.0対応 Add End